/* eslint-disable no-unused-vars */
export enum ContainerSizes {
  FULL = 'full',
  EXTRA_LARGE = 'extraLarge',
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
